import { FORBO_ICONS_API_BASE_URL } from "../constants/forbo";

export function buildIconsByEmailUrl(email: string): string {
  const params = new URLSearchParams({ email });
  return `/api/icons?${params.toString()}`;
}

export function buildIconTrackingUrl(email: string, ids: string[]): string {
  const params = new URLSearchParams({
    email,
    ids: ids.join(","),
  });

  return `/api/log?${params.toString()}`;
}

export function toSecureIconUrl(iconUrl: string): string {
  if (!iconUrl) {
    return iconUrl;
  }

  const normalizedUrl = iconUrl.replace(/^http:\/\//i, "https://");

  try {
    return new URL(normalizedUrl, `${FORBO_ICONS_API_BASE_URL}/`).toString();
  } catch {
    return normalizedUrl;
  }
}
